import type { VaspSearchState } from "../useVaspSearch";
import { useVaspSearchDropdownController } from "./VaspSearchDropdown.controller";
import { VaspSearchDropdownPresentation } from "./VaspSearchDropdown.pres";

interface VaspSearchDropdownProps {
  vaspSearch: VaspSearchState;
  vaspSelectionError?: string;
  manualVaspNameError?: string;
  manualVaspWebsiteError?: string;
}

export const VaspSearchDropdown = ({
  vaspSearch,
  vaspSelectionError,
  manualVaspNameError,
  manualVaspWebsiteError,
}: VaspSearchDropdownProps) => {
  const controller = useVaspSearchDropdownController({ vaspSearch });

  return (
    <VaspSearchDropdownPresentation
      vaspSearch={vaspSearch}
      vaspSelectionError={vaspSelectionError}
      manualVaspNameError={manualVaspNameError}
      manualVaspWebsiteError={manualVaspWebsiteError}
      {...controller}
    />
  );
};
